import { defineMessages } from 'react-intl';

export default defineMessages({
    compOnlyHeaderDescription: {
        id: 'common.component.ComprehensiveOnlyDescriptionComponent.Comprehensive Only Coverage',
        defaultMessage: 'Comprehensive Only Coverage'
    }
});
